import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { modGameList_template } from "../components/templates/modGameList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class mod_game_list extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: modGameList_template;


    protected getModuleName(): string {

      return "mod_game_list";
    }

    buildContent(): Array<Element> {

        this.elementsList = new modGameList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Mod Games List");

        return [this.elementsList.build()];
    }

    public fillPage() {

      this.filterList();
    }

    protected paginationOnPageClick(){

      this.filterList();
    }

    protected gamesListReorder(){

      this.filterList();
    }

    protected filterSimpleOnChange(){

      this.viewModel.list.pagination.pageNumber(1);
      this.filterList();
    }

    protected filterSimpleCancel(){

      if( this.XHRHdl ){
          this.XHRHdl.cancelAndReset();
      }
    }

    protected filterList() {

      if (this.XHRHdl) {
          this.XHRHdl.cancelAndReset();
      }

      // LOADING : starts
      this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

      let usrReq_url: string = '/api/mod/active-games-list/get';
      let usrReq_params: Array<Array<string>> = [];
      usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
      this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
      this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){

              let responseParsed = JSON.parse(req.request.response);
              obj.updateList(responseParsed);
          });
          obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
      }
    }

    protected updateList(responseParsed: any){

      let gamesToSet = responseParsed.data;

      this.elementsList.setGames(gamesToSet);

      let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
      this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

      this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected addGame(idTag) {
      let usrReq_url: string = '/api/mod/active-games-list/add/' + idTag + '/';
      let usrReq_params: Array<Array<string>> = [];
      //usrReq_params.push(["data", ko.toJSON(gameToAdd)]);
      this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

      this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
      this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
      this.XHRHdl.onReadyStateFunction = this.onSaveGameRequestReturn;
      this.XHRHdl.execute();
    }

    protected onSaveGameRequestReturn(req, obj){

      return function(){
          obj.manageResponse(req, obj, function(){
              obj.filterList();
          });
      }
    }

    protected deleteGame(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let formReq_url = "/api/mod/active-games-list/delete/" + data.tag.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "<strong>" + responseParsed.data.name + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule();
                    obj.filterList();
                })

                //obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

    protected getSuggestions(keyword, idSourceElement) {
        if (idSourceElement == "filterAutocomplete_tagFilter") {
            this.getTagsSuggestion(keyword);
        }
    }

    protected getTagsSuggestion(keyword) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filter: {
                keyword: keyword,
                idTagType: 222,
                getSelectable: false,
                getNonSelectable: false
            }
        };

        let usrReq_url: string = '/api/search/tag/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    obj.elementsList.tagFilter.setOptions(responseParsed.data.tags);
                }
            });
        }
    }

    protected onAutocompleteOptionChange(idElement) {
        if (idElement == "filterAutocomplete_tagFilter") {
            let tag = this.elementsList.tagFilter.getTemplateViewModel().optionObj();
            if (tag) {
                this.elementsList.getTemplateViewModel().selectedTag(tag);
            }
        }
    }

    protected onAutocompleteInputClear(idElement) {
        if (idElement == "filterAutocomplete_tagFilter") {
            this.elementsList.getTemplateViewModel().selectedTag(null);
        }
    }

    protected onAutocompleteInputClick(idElement) {}
    protected onAutocompleteAddNewSelected(idElement) {}
    protected onAutocompleteAddNewInputChange(idElement?) {}

    public getIdBrand() {
      return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/mod_game_list.ts